import React from 'react';
import { useStyles, StyledTableCell, StyledTableRow } from './UsersStyle';
import NoteIcon from '../../../assets/icons/userPageInfoIcon.svg';
import SearchIcon from '../../../assets/icons/searchIcon.svg';
import Table from '@material-ui/core/Table';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import TableBody from '@material-ui/core/TableBody';
import EyeIcon from '../../../assets/icons/eyeIcon.svg';
import CopyIcon from '../../../assets/icons/copyIcon.svg';
import ThreeDotsIcon from '../../../assets/icons/threeDotsIcon.svg';
import UseUsers from './UseUsers';
export default function Users({ headings }) {
    const styles = useStyles();
    const [{ data, searchVal, setSearchVal, copyHandler, copiedAlert, showPasswordHandler, securePasswordHandler }] = UseUsers();
    return (
        <div>
            <div className={styles.createServiceUserContainer}>
                <p className={styles.createSrvceUserTxt}>Create a Service user</p>
                <p className={styles.inputLabel}>Username</p>
                <div className={styles.inputAndBtnRow}>
                    <input className={styles.userNameInput} type="text" />
                    <button className={styles.addBtn}>Add service user</button>
                </div>
            </div>
            <div className={styles.noteContainer}>
                <div className={styles.infoIconContainer}>
                    <img width={36} height={36} src={NoteIcon} alt="icon" />
                </div>
                <div className={styles.noteTextContainer}>
                    <p className={styles.noteText}>NOTE</p>
                    <p className={styles.importantNote}>Looking for CA certificate? You may download the CA certificate from the Overview Tab</p>
                </div>
            </div>
            <p className={styles.srvcUserNameTxt}>Service Users</p>
            <div className={styles.inputWithIconContainer}>
                <input onChange={(e) => setSearchVal(e.target.value)} className={styles.searchInput} type="text" placeholder='Search by user name' />
                <div className={styles.iconContainer}>
                    <img src={SearchIcon} alt="icon" />
                </div>
            </div>
            <TableContainer component={Paper} className={styles.eventContainer} >
                <Table className={styles.table} size="medium" aria-label="customized table">
                    <TableHead>
                        <TableRow>
                            {
                                headings?.map((item) => {
                                    return (
                                        <StyledTableCell >{item}</StyledTableCell>
                                    )
                                })
                            }
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {
                            data?.filter((item) => {
                                if (item?.userName?.toLowerCase().includes(searchVal.toLowerCase())) {
                                    return item;
                                }
                            })?.map((item, index) => (
                                <StyledTableRow >
                                    <StyledTableCell >{item?.userName}</StyledTableCell>
                                    <StyledTableCell >
                                        <div className={styles.passwordInputAndCopyIconRow}>
                                            <input disabled={item?.showPassword?false:true} className={item?.showPassword ? styles.visiblePasswordInput : styles.passwordInput} value={item?.showPassword ? item?.password : securePasswordHandler(item?.password)} type={'text'} />
                                            <div onClick={() => showPasswordHandler(item)} className={item?.showPassword ? styles.passwordVisibleEyeContainer : styles.eyeIconContainer}><img src={EyeIcon} alt="eye-icon" /></div>
                                            <img onClick={() => copyHandler(item?.password)} className={styles.copyIcon} src={CopyIcon} alt="copy-icon" />
                                        </div>
                                    </StyledTableCell>
                                    <StyledTableCell>
                                        <div className={styles.certificateBtnsRow}>
                                            <button className={styles.certificateBtn}>Show access key</button>
                                            <button className={styles.certificateBtn}>Show access cert</button>
                                        </div>
                                    </StyledTableCell>
                                    <StyledTableCell ><button className={styles.validityBtn}>Up-to-date</button></StyledTableCell>
                                    <StyledTableCell ><img src={ThreeDotsIcon} alt="dots-icon" /></StyledTableCell>
                                </StyledTableRow>
                            ))}
                    </TableBody>
                </Table>
            </TableContainer>
            {copiedAlert &&
                <div className={styles.copiedAlertContainer}>
                    <p>Copied</p>
                </div>
            }
        </div>
    )
}
